import React, { FC, useMemo } from 'react';
import { AnalyticsUsersByRoleProps } from './AnalyticsUsersByRoleProps';
import { BarChartPro } from '@mui/x-charts-pro/BarChartPro';
import { groupByDate } from './utils';
import AnalyticsLoader from '../AnalyticsLoader';

const AnalyticsUsersByRole: FC<AnalyticsUsersByRoleProps> = ({
  data,
  grouping,
  loading,
}) => {
  const dataset = useMemo(() => groupByDate(data, grouping), [data, grouping]);

  return (
    <AnalyticsLoader loading={loading}>
      <BarChartPro
        dataset={dataset}
        xAxis={[
          {
            scaleType: 'band',
            dataKey: 'date',
            tickLabelStyle: { angle: -45 },
          },
        ]}
        series={[
          {
            dataKey: 'EXP_PROJECT_CREATOR',
            label: 'Project Creator',
            stack: 'total',
          },
          { dataKey: 'EXP_ADMIN', label: 'Admin', stack: 'total' },
          { dataKey: 'EXP_SUPER_ADMIN', label: 'Super Admin', stack: 'total' },
        ]}
        slots={{
          noDataOverlay: () => null,
        }}
      />
    </AnalyticsLoader>
  );
};

export default AnalyticsUsersByRole;
